export const colors = {
  800: [
    "#6a1b9a",
    "#4527a0",
    "#c62828",
    "#283593",
    "#1565c0",
    "#0277bd",
    "#00838f",
    "#00695c",
    "#2e7d32",
    "#558B2F",
    "#9E9D24",
    "#F9A825",
    "#4E342E",
    "#424242",
    "#ff8f00",
    "#d84315",
  ],
  500: [
    "#7E57C2",
    "#EF5350",
    "#EC407A",
    "#AB47BC",
    "#5C6BC0",
    "#42A5F5",
    "#29B6F6",
    "#26C6DA",
    "#26A69A",
    "#66BB6A",
    "#9CCC65",
    "#FFCA28",
    "#FFA726",
  ],
};

export const genres = [
  { id: 28, name: "Action" },
  { id: 12, name: "Adventure" },
  { id: 16, name: "Animation" },
  { id: 35, name: "Comedy" },
  { id: 80, name: "Crime" },
  { id: 99, name: "Documentary" },
  { id: 18, name: "Drama" },
  { id: 10751, name: "Family" },
  { id: 14, name: "Fantasy" },
  { id: 36, name: "History" },
  { id: 27, name: "Horror" },
  { id: 10402, name: "Music" },
  { id: 9648, name: "Mystery" },
  { id: 10749, name: "Romance" },
  { id: 878, name: "Science Fiction" },
  { id: 10770, name: "TV Movie" },
  { id: 53, name: "Thriller" },
  { id: 10752, name: "War" },
  { id: 37, name: "Western" },
];

export default { colors, genres };
